import React, { useState } from 'react'
import { useNavigate } from 'react-router-dom';
import { API_BASE_URL } from '../config';
import axios from 'axios';
import Swal from 'sweetalert2';
import Loader from '../components/Loader';
import Footer from '../components/Footer/footer';
import Navbar from '../components/Navbar/navbar';
import ShowToast from '../components/ShowToast/index'

function ForgotPasswordBusiness()
{

    const navigate = useNavigate();
    const [loading, setLoading] = useState(false);
    const [email, setEmail] = useState('');
    const [error, setError] = useState('');

    const handleSubmit = async (e) =>
    {
        e.preventDefault();
        const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;

        if (!emailRegex.test(email))
        {
            setError('Please enter a valid email address.');
        } else
        {
            setError('');
            setLoading(true);
            await axios.post(`${API_BASE_URL}/api/BusinessUser/forgotPassword`, { email })
                .then(response =>
                {
                    setLoading(false);
                    if (response.data.email !== null)
                    {
                        Swal.fire({
                            icon: 'success',
                            title: 'Reset Password Link Sent!',
                            text: 'Please check your email for the reset password link.',
                            timer: 1500,
                            showConfirmButton: false,
                            customClass: "confirmation-popup",
                        }).then(() =>
                        {
                            navigate('/login')
                        });
                    }
                })
                .catch(error =>
                {
                    setLoading(false);
                    ShowToast('error', error.response.data.message.join(' '));
                });
        }
    };

    const handleEmailChange = (e) =>
    {
        const value = e.target.value;
        setEmail(value);
        const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
        if (emailRegex.test(value))
        {
            setError('');
        }
    };


    return (
        <>
            {loading ? <Loader /> : null}
            <Navbar />
            <div>
                <section className="inner-page-banner">
                    <div className="container">
                        <div className="row">
                            <div className="col-sm-12">
                                <h1 className="banner-heading">Forgot Password</h1>
                            </div>
                        </div>
                    </div>
                </section>
                <section className="onboarding-form bottom-hammer-vector">
                    <div className="container">
                        <div className="row">
                            <div className="col-sm-12">
                                <div className="form-main">
                                    <div className="form-row">
                                        <div className="form-group">
                                            <label>Please enter your email address to receive a password reset link.</label>
                                            <div className="form-control-wrapper">
                                                <input
                                                    type="email"
                                                    value={email}
                                                    onChange={handleEmailChange}
                                                    placeholder="Enter your email"
                                                    className='form-control'
                                                    required
                                                />
                                                {error && <span className="error">{error}</span>}
                                            </div>
                                        </div>
                                    </div>
                                    <div className="onboarding-form-button">
                                        <button onClick={handleSubmit}>Submit</button>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </section>
            </div>
            <Footer />
        </>
    )
}

export default ForgotPasswordBusiness
